// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"image-block_wrapper__0Vbh9","wrapper__image":"image-block_wrapper__image__yi8F7","wrapper__image--compact":"image-block_wrapper__image--compact__2VacQ"};